import jQuery from 'jquery';

export default jQuery(function() {
    jQuery('.js-director__social-trigger').click(function() {
        const trigger = jQuery(this);

        trigger.toggleClass('is-clicked');

        trigger.closest('.js-director').find('.js-director__social').toggleClass('is-open');
    })
});
